<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="规则Code：" prop="code">
                    <el-input v-model.trim="form.code" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="规则名称：" prop="name">
                    <el-input v-model.trim="form.name" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="padding-right: 16px;">
                <el-button type="primary" size="small" @click="addRule">新建</el-button>
            </div>
        </div>
        <el-table :data="tableList" size="mini">
            <el-table-column label="规则ID" width="320">
                <template v-slot="scope">
                    <span>{{ scope.row.code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="规则名称">
                <template v-slot="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间(UTC)" prop="created_at" :formatter="(row) =>
                row.created_at &&
                dayjs.utc(row.created_at).format('YYYY-MM-DD HH:mm:ss')
                ">
            </el-table-column>
            <el-table-column label="操作" width="220px">
                <template v-slot="scope">
                    <router-link :to="'/iot/content/ruleadd/' + scope.row.code">
                        <el-button type="info" size="mini" class="btnClass">编辑</el-button>
                    </router-link>
                    <el-button type="primary" size="mini" style="margin-left: 10px;"
                        @click="copyRule(scope.row)">复制</el-button>
                    <el-button type="danger" size="mini" @click="deleteRule(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router'
import util from '../../../../util/util'
import api from '../../../../axios/api'
import dayjs from 'dayjs'
const utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

export default {
    setup() {
        const router = useRouter()
        const form = reactive({
            code: '',
            name: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const tableList = ref([])

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.ContentManageRuleList({
                ...toRaw(form),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { list, page_info } = res.data.data
                tableList.value = list
                pagination.total = page_info.total
                pagination.page = page_info.current_page
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const addRule = () => {
            router.push('/iot/content/ruleadd/0')
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        const copyRule = (row) => {
            ElMessageBox.confirm('你确定要复制这一条规则吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await api.ContentManageRuleCopy({
                        code: row.code
                    })
                    if (res.data.code == 200) {
                        ElMessage.success('复制成功')
                        onSearch()
                    } else {
                        ElMessage.error('复制失败' + res.data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    ElMessage.info('已取消复制')
                })
        }

        const deleteRule = (row) => {
            ElMessageBox.confirm('你确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await api.ContentManageRuleDelete({
                        code: row.code
                    })
                    if (res.data.code == 200) {
                        ElMessage.success('删除成功')
                        onSearch()
                    } else {
                        ElMessage.error('删除失败' + res.data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    ElMessage.info('已取消删除')
                })
        }

        onMounted(() => {
            onSearch()
        })

        return {
            form,
            onSearch,
            tableList,
            formRef,
            pagination,
            handleCurrentChange,
            addRule,
            resetForm,
            deleteRule,
            util,
            dayjs,
            copyRule
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
